/**
 * Query Client Registry
 *
 * Holds a reference to the single QueryClient mounted in `app/providers.tsx`
 * so non-React modules (axios/fetch interceptors) can invalidate React Query
 * caches after a write. Without this, interceptors have no way to reach the
 * mounted client and lists stay stale until a full reload / re-login.
 */
import type { QueryClient } from '@tanstack/react-query';

let queryClient: QueryClient | null = null;

export function setQueryClient(client: QueryClient): void {
  queryClient = client;
}

export function getQueryClient(): QueryClient | null {
  return queryClient;
}
